import { Component } from '@angular/core';

@Component({
  selector: 'app-lock-thin',
  templateUrl: './lock-thin.component.html',
  styleUrls: ['./lock-thin.component.scss']
})
export class LockThinComponent {

}
